module.exports = __webpack_public_path__ + "img/11.c4ac9d3a.jpg";